import React from 'react';
import './MentionFormatter.css';

const MentionFormatter = ({ text }) => {
  const formatMentionsInText = (text) => {
    const mentionRegex = /@([a-zA-Z0-9._-]+)/g;
    const parts = text.split(mentionRegex);
    
    return parts.map((part, index) => {
      // If this is an odd index, it's a username from the regex capture group
      if (index % 2 === 1) {
        return (
          <span key={index} className="mention">
            @{part}
          </span>
        );
      }
      return part;
    });
  };

  return <span>{formatMentionsInText(text)}</span>;
};

export default MentionFormatter;